import { render, staticRenderFns } from "./BuildingDetails.vue?vue&type=template&id=762bd964&lang=pug&"
import script from "./BuildingDetails.vue?vue&type=script&lang=ts&"
export * from "./BuildingDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports